import { createSlice } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';

// Slice
const initialAdminUser = localStorage.getItem('adminUser')
  ? JSON.parse(localStorage.getItem('adminUser'))
  : null

const slice = createSlice({
  name: 'adminUser',
  initialState: {
    adminUser: initialAdminUser,
  },
  reducers: {
    loginAdminSuccess: (state, action) => {
      state.adminUser = action.payload;
      localStorage.setItem('adminUser', JSON.stringify(action.payload));
    },
    logoutAdminSuccess: (state, action) =>  {
      state.adminUser = null;
      localStorage.removeItem('adminUser');
    },
  },
});

export default slice.reducer;

// Actions
const { loginAdminSuccess, logoutAdminSuccess } = slice.actions;

export const loginAdmin = (currentUser) => async dispatch => {
  try {
    // const res = await api.post('/api/auth/login/', { username, password })
    dispatch(loginAdminSuccess(currentUser));
  } catch (e) {
    return console.error(e.message);
  }
}

export const logoutAdmin = () => async dispatch => {
  try {
    // const res = await api.post('/api/auth/logout/')
    return dispatch(logoutAdminSuccess())
  } catch (e) {
    return console.error(e.message);
  }
}
